export type SettlementType = "none" | "settled";

const helperWillNotCompileInCaseNewSettlementIsAdded: {
  [type in SettlementType]: void;
} = {
  none: undefined,
  settled: undefined,
};

export function allSettlementTypes(): SettlementType[] {
  return Object.keys(
    helperWillNotCompileInCaseNewSettlementIsAdded
  ) as SettlementType[];
}

export function isSettlementType(type: string): type is SettlementType {
  return Object.keys(helperWillNotCompileInCaseNewSettlementIsAdded).includes(
    type
  );
}
